import styled from "styled-components";
import { FiSend } from "react-icons/fi";

export const ContactContainer = styled.div`
  background-color: #ffb400;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContactForm = styled.form`
  background-color: #1b1b1b;

  display: grid;

  margin: 80px;
  padding: 40px 30px;
  max-width: 600px;
  width: 100%;

  border-radius: 25px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 620px) {
    margin: 10px;
    padding: 40px 20px;
    width: 95%;
  }
`;

export const ContactLabel = styled.label`
  font-size: 1.2rem;
  margin-bottom: 5px;
  color: #fefefa;

  @media screen and (max-width: 620px) {
    font-size: 1rem;
  }
`;

export const ContactInput = styled.input`
  font-size: 1.5rem;
  margin-bottom: 32px;
  border: none;
  border-radius: 5px;

  padding: 16px;
  color: #1b1b1b;
  width: 100%;

  @media screen and (max-width: 620px) {
    font-size: 1.2rem;
    margin-bottom: 20px;
    padding: 12px;
  }
`;

export const ContactText = styled.textarea`
  font-size: 1.5rem;
  padding: 20px;
  border-radius: 10px;
  height: 200px;
  color: #1b1b1b;
  margin-bottom: 50px;
  width: 100%;

  @media screen and (max-width: 620px) {
    font-size: 1.2rem;
    padding: 12px;
    margin-bottom: 40px;
  }
`;

export const ContactButton = styled.button`
  font-size: 1.5rem;
  font-weight: bold;
  padding: 1rem 2rem;

  border-radius: 5px;
  background-color: #96a9fe;
  white-space: nowrap;

  color: #fefefa;

  outline: none;
  border: none;
  cursor: pointer;

  transition: all 0.2s ease-in-out;
  text-decoration: none;

  @media screen and (max-width: 620px) {
    font-size: 1.2rem;
  }

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: #ffb400;
  }
`;

export const SendIcon = styled(FiSend)`
  margin-right: 5px;
`;
